import type { CSSProperties } from 'react';

/**
 * Hide an element visually, but keep it accessible to screen readers and keep
 * it able to receive events and focus.
 */
export const visuallyHidden = {
	borderStyle: 'none',
	clip: 'rect(0 0 0 0)',
	height: '1px',
	margin: -1,
	overflow: 'hidden',
	padding: 0,
	position: 'absolute',
	whiteSpace: 'nowrap',
	width: '1px',
} as const satisfies CSSProperties;
